var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-view',{staticStyle:{"position":"relative","padding-bottom":"15rem","height":"100vh"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }